export default __webpack_public_path__ + "static/media/vkpic3.198ac711.png";